var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vm-progress',{attrs:{"type":_vm.type,"percentage":_vm.value,"trackColor":_vm.color.track,"strokeColor":_vm.color.progress,"showText":true,"textInside":_vm.textInside,"width":_vm.width,"strokeWidth":_vm.strokeWidth}}),(_vm.value === _vm.progress)?_vm._t("done"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }